import React, { useCallback, useRef, useState } from 'react';
import { useModalActions } from '../../Modals/modalActions';
import { useSelection } from '@cube3/state/src/redux/components/useSelection';
import { ModalMenuUI } from '@cube3/ui/src/Modal/ModalMenuUI';
import Button from '@cube3/ui/src/Buttons/Button';
import { Typography } from '@cube3/cubicle/src/core/atoms/Typography';
import CheckBoxStateless from '@cube3/ui/src/Buttons/CheckBoxStateless';
import { List, ListItem } from '@material-ui/core';
import { SelectionItemInterface } from '@cube3/state/src/redux/ducks/selections';
import { HBox } from '@cube3/cubicle/src/core/templates/layout/Flex';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';

export interface RadioExportModalProps {
    assets: SelectionItemInterface[];
    stations: string[];
}

const Broadcasters = [
    {
        id: 'bnr',
        value: 'BNR Nieuwsradio'
    },
    {
        id: 'dpg',
        value: 'DPG Media',
        tooltip: 'Qmusic, JOE, theme channels'
    },
    {
        id: 'epower',
        value: 'E Power',
        tooltip: 'Kink and regional channels'
    },
    {
        id: 'funx',
        value: 'FunX'
    },
    {
        id: 'mediahuis_radio',
        value: 'Mediahuis Radio',
        tooltip: 'Radio Veronica, 100% NL, SLAM!, Sublime, theme channels'
    },
    {
        id: 'oms',
        value: 'OMS',
        tooltip: 'Grand Prix - Sport Radio, Radio 10 Brabant, Decibel Radio, 4ever49, AAS Network'
    },
    {
        id: 'ster',
        value: 'Ster',
        tooltip: 'NPO Radio 1, NPO Radio 2, NPO 3FM, NPO Klassiek, NPO Radio 5 and ORN Radio'
    },
    {
        id: 'talpa',
        value: 'Talpa Radio',
        tooltip: 'Radio 538, Radio 10, Sky Radio, theme channels'
    }
];

interface Props {
    modalContext?: {
        platform?: 'Radio';
    };
}

export const RadioExportDestinationModal: React.FC<Props> = () => {
    const { selection: initialSelection } = useSelection();
    const { current: assets } = useRef(initialSelection);
    const [selectedStationIds, setSelectedStationIds] = useState<string[]>([]);
    const { previousModal, goBackModals, openModal } = useModalActions();

    const onNext = useCallback(() => {
        openModal('radio_export_data', { assets, stations: selectedStationIds });
    }, [openModal, assets, selectedStationIds]);

    const disableNext = !selectedStationIds.length;

    const handleCancel = useCallback(() => {
        goBackModals(2);
    }, [goBackModals]);

    return (
        <ModalMenuUI
            extraWide={true}
            title="Export Radio ad • Select destination"
            onCloseEvent={previousModal}
            footerRightComponent={
                <>
                    <Button
                        text="Cancel"
                        colorVariant="ghost2"
                        onClick={handleCancel}
                    />
                    <Button
                        disabled={disableNext}
                        colorVariant="filled1"
                        text="Next"
                        onClick={onNext}
                    />
                </>
            }
        >
            <Typography color="default">Select a destination</Typography>
            <div style={{ height: 8 }} />
            <List style={{ paddingLeft: 0 }}>
                {Broadcasters.map((des) => (
                    <ListItem key={des.id} style={{ padding: '4px 0' }}>
                        <HBox align='center' gap={8}>
                            <CheckBoxStateless
                                text={des.value}
                                checked={selectedStationIds.includes(des.id)}
                                onChange={(checked) =>
                                    setSelectedStationIds((prev) =>
                                        checked ? [...prev, des.id] : prev.filter((existingID) => existingID !== des.id)
                                    )
                                }
                            />
                            <Typography colorVariant='03' variant={SizeVariants.sm}>{des.tooltip}</Typography>
                        </HBox>
                    </ListItem>
                ))}
            </List>
        </ModalMenuUI>
    );
};